import React, { useState } from 'react';
import {
    Box,
    Button,
    Heading,
    Layer,
    Select,
    SelectMultiple,
    TextArea,
    Text,
} from 'grommet';
import { Close } from 'grommet-icons';
import PropTypes from 'prop-types';
import { Utils } from '../../helpers/Utils';
import JobService from '../../api/job-service';

export const MessageCandidatesButton = ({ candidacyStatusEnums, job }) => {
    const [showModal, setShowModal] = useState(false);

    return (
        <Box>
            <Button
                primary
                size="large"
                label="Message candidates"
                onClick={() => setShowModal(true)}
            />
            {showModal && (
                <MessageCandidatesModal
                    candidacyStatusEnums={candidacyStatusEnums}
                    job={job}
                    setShowModal={setShowModal}
                />
            )}
        </Box>
    );
};

const MessageCandidatesModal = ({
    candidacyStatusEnums,
    job,
    setShowModal,
}) => {
    const [message, setMessage] = useState('');
    const [messageType, setMessageType] = useState('email');
    const [candidacyStatuses, setCandidacyStatuses] = useState([]);
    const [buttonBusy, setButtonBusy] = useState();
    const [errorMessage, setErrorMessage] = useState('');

    const candidacyStatusEnumOptions = candidacyStatusEnums.map((x) => ({
        ...x,
        label: Utils.convertEnumStringToLabel(x.name),
    }));

    const handleSelectChange = ({ value }) => {
        setCandidacyStatuses(value);
    };

    const sendMessage = async () => {
        setCandidacyStatuses([]);
        try {
            setButtonBusy(true);
            await new JobService().sendMessageToCandidates(
                job.id,
                message,
                messageType,
                candidacyStatuses.map((s) => s.name),
            );
            setShowModal(false);
        } catch (error) {
            setErrorMessage(
                error.message || 'There was an issue sending the message.',
            );
            setButtonBusy(false);
        }
    };

    return (
        <Layer
            onClickOutside={() => setShowModal(false)}
            onEsc={() => setShowModal(false)}
            position="center">
            <Box
                background="white"
                pad="medium"
                round="6px"
                border={{ color: 'enrich-green-light', size: '3px' }}
                alignSelf="center"
                gap="30px">
                <Box direction="row" gap="20px" justify="between">
                    <Heading level="3" margin={{ vertical: 'none' }}>
                        Send manual report for {job.title}
                    </Heading>
                    <Box align="end">
                        <Close
                            onClick={() => {
                                setShowModal(false);
                            }}
                            cursor="pointer"
                        />
                    </Box>
                </Box>
                <Box>
                    <Text weight="bold">Message Type</Text>
                    <Select
                        options={['email', 'sms']}
                        onChange={({ value }) => setMessageType(value)}
                        value={messageType}
                    />
                </Box>
                <Box>
                    <Text weight="bold">Status Filter</Text>
                    <SelectMultiple
                        options={candidacyStatusEnumOptions}
                        labelKey="name"
                        onChange={handleSelectChange}
                        value={candidacyStatuses}
                    />
                </Box>
                <Box>
                    <Text weight="bold">Message</Text>
                    <TextArea
                        placeholder="Message"
                        value={message}
                        onChange={(event) => setMessage(event.target.value)}
                    />
                </Box>
                <Box>
                    <Button
                        primary
                        size="large"
                        busy={buttonBusy}
                        disabled={!message.length && !candidacyStatuses.length}
                        label="Send message"
                        style={{ width: '220px', height: '50px' }}
                        alignSelf="center"
                        onClick={sendMessage}
                    />
                </Box>
                {errorMessage.length > 0 && (
                    <Box>
                        <Text color="red">{errorMessage}</Text>
                    </Box>
                )}
            </Box>
        </Layer>
    );
};

MessageCandidatesButton.propTypes = {
    candidacyStatusEnums: PropTypes.array,
    job: PropTypes.object,
};

MessageCandidatesModal.propTypes = {
    candidacyStatusEnums: PropTypes.array,
    job: PropTypes.object,
    setShowModal: PropTypes.func,
};
